// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CommentOutlinedSvg from "@ant-design/icons-svg/es/asn/CommentOutlined";
import AntdIcon from '../components/AntdIcon';

var CommentOutlined = function CommentOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CommentOutlinedSvg
  }));
};

CommentOutlined.displayName = 'CommentOutlined';
export default /*#__PURE__*/React.forwardRef(CommentOutlined);